var exports = {
  "O": "Placeholder__e6a8JF",
};

module.exports = exports;
